import React from "react";
import "../../Styles/certified/isource.css";

export default function Finzly() {
  return (
    <>
      <div className="isource-certified-details-section">
        <div className="isource-certified-details-title">
          OUTSTANDING WORKPLACES CERTIFIED COMPANIES
        </div>
        <div className="isource-certified-details-container">
          {/* Left: Badge and Company Info side by side */}
          <div className="isource-certified-details-left">
            <img
              src="/assets/isource/aug.png"
              alt="Outstanding Workplaces Certified"
              className="isource-certified-badge"
            />
            <div className="isource-certified-company-names">
              <a href="https://isourceindia.com/" target="_blank" rel="noopener noreferrer">
              <img
                src="/assets/isource/i_logo.png"
                alt="Walkzero Logo"
                className="isource-certified-company-logo"
              />
            </a>
              <h1 className="isource-certified-full-name">
           iSource ITES Private Limited
              </h1>
            </div>
          </div>
          {/* Right: Company Image */}
          <div className="isource-certified-details-right">
            <img
              src="/assets/isource/isource_4.jpeg"
              alt="Finzly Office"
              className="isource-certified-company-image"
            />
          </div>
        </div>
        {/* Description section below */}
        <div className="isource-certified-description">
          <h2>
            Why iSource ITES Private Limited is an Outstanding Workplaces
          </h2>
          <p>
           	iSource is an established 18-year-old, people-driven
healthcare BPO/KPO headquartered in California. We offer services committed
to revenue cycle management, healthcare documentation management, real-time accessibility and healthcare IT services. We are proud to
have people, products, system solutions, software, and services that deliver
clear added value by providing billing, coding, automation, and analytics
services, which relieves financial and administrative demands on healthcare
providers.


          </p>
          
        </div>
        {/* Info Cards Section */}
        <div className="isource-certified-info-cards">
          <div className="isource-certified-info-card">
            <div className="isource-certified-info-title">COMPANY SIZE</div>
            <div className="isource-certified-info-value">260 Employees</div>
          </div>
          <div className="isource-certified-info-card">
            <div className="isource-certified-info-title">INDUSTRY</div>
            <div className="isource-certified-info-value"> 	KPO

</div>
          </div>
          <div className="isource-certified-info-card">
            <div className="isource-certified-info-title">CONNECT</div>
            <div className="isource-certified-info-icons">
              <span className="isource-certified-icon-round">
                <a href="https://isourceindia.com/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/website.png" alt="Website" />
                </a>
              </span>
              <span className="isource-certified-icon-round">
                <a href="https://www.linkedin.com/company/isource-ites/" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/linkedin.png" alt="LinkedIn" />
                </a>
              </span>
              <span className="isource-certified-icon-round">
                <a href="https://www.facebook.com/iSourceIndia" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/facebook.png" alt="Facebook" />
                </a>
              </span>
            </div>
          </div>
          <div className="isource-certified-info-card">
            <div className="isource-certified-info-title">LOCATION (HQ)</div>
            <div className="isource-certified-info-value">	California, US </div>
          </div>
        </div>
        {/* Recognitions Section */}
        <div className="isource-certified-recognition-section">
          <h2 className="isource-certified-recognition-title">
            Recognitions awarded by Outstanding Workplaces
          </h2>
          <div className="isource-certified-recognition-badge">
            <img
              src="/assets/isource/aug.png"
              alt="Outstanding Workplaces Certified"
              className="isource-certified-recognition-image"
            />
          </div>
          <div className="isource-certified-recognition-label">
            Outstanding Workplaces - Certified
          </div>
        </div>
        {/* Life at Finzly Section */}
        <div className="isource-certified-life-section">
          <h2 className="isource-certified-life-title">
            Life at 	iSource ITES Private Limited
          </h2>
          <div className="isource-certified-life-gallery">
            <div className="isource-certified-life-col">
              <img src="/assets/isource/isource_1.jpeg" alt="Office 1" className="isource-certified-life-img" />
              <img src="/assets/isource/isource_2.jpeg" alt="Team 1" className="isource-certified-life-img" />
            </div>
            <div className="icom-certified-life-col isource-certified-life-center">
              <img src="/assets/isource/isource_6.jpeg" alt="Main Office" className="isource-certified-life-img isource-certified-life-img-large" />
            </div>
            <div className="isource-certified-life-col">
              <img src="/assets/isource/isource_3.jpeg" alt="Office 2" className="isource-certified-life-img" />
              <img src="/assets/isource/isource_5.jpeg" alt="Team 2" className="isource-certified-life-img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
